import { render } from "./SectionCta.vue?vue&type=template&id=6a0dbe82&scoped=true"
import script from "./SectionCta.vue?vue&type=script&lang=js"
export * from "./SectionCta.vue?vue&type=script&lang=js"

import "./SectionCta.vue?vue&type=style&index=0&id=6a0dbe82&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a0dbe82"]])

export default __exports__